import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../../api';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Master Mata Uang',
    title_daftar: 'Daftar Nilai Tukar',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Mata Uang',
        href: '/adm/fin/master/mata-uang',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields: [
      {
        key: 'code_currency',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'currency_name',
        label: 'Nama Mata Uang',
        sortable: true,
      },
      {
        key: 'symbol',
        label: 'Simbol',
        sortable: true,
      },
      {
        key: 'is_primary',
        label: 'Mata Uang Utama',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_nilai_tukar: [
      {
        key: 'code_currency',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'currency_name',
        label: 'Nama Mata Uang',
        sortable: true,
      },
      {
        key: 'date_kurs',
        label: 'Per Tanggal',
        sortable: true,
      },
      {
        key: 'nominal',
        label: 'Nilai Tukar',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    currency: [],
    form: {
      currency_name: '',
      symbol: '',
      exchange_rate: '',
      date_exchange: '',
      acc_piutang: '',
      acc_hutang: '',
      acc_bayar_bank: '',
      acc_bayar_tunai: '',
      acc_dp_beli: '',
      acc_dp_jual: '',
    },
    form_nilai_tukar: {
      id_currency: '',
      date_kurs: '',
      nominal: 0,
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  form_nilai_tukar(state) {
    return state.data.form_nilai_tukar;
  },
};

export const mutations = {
  changeCurrency(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchCurrency(context, params = null) {
    let result = await ApiGetRequest(`fin/currency`, params);
    return !result.error ? result.data.object : [];
  },

  async getAllCurrency({ commit }) {
    commit('changeCurrency', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/currency`);
    commit('changeCurrency', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },

  async getCurrency({ commit, state }) {
    commit('changeCurrency', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/currency`, params);
    commit('changeCurrency', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },

  async getCurrencyList({ commit, state }) {
    commit('changeCurrency', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/currency`, params);
    commit('changeCurrency', {
      currency: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },

  async getCurrencyPrice({ commit, state }) {
    commit('changeCurrency', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/currency/price`, params);
    commit('changeCurrency', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },

  async getDetailCurrency({ commit, state }, payload = null) {
    commit('changeCurrency', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/currency/${payload.id}`);
    commit('changeCurrency', {
      loading: false,
    });

    if (!result.error) {
      commit('changeCurrency', {
        form: {
          ...data.form,
          ...result.data.object,
          date_exchange: result.data.object
            ? moment(result.data.object.date_exchange).format('DD/MM/YYYY')
            : '',
        },
      });
    }

    return result.error ? false : true;
  },

  async getDetailRateCurrency({ commit, state }, payload = null) {
    commit('changeCurrency', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/currency/price/${payload.id}`);
    commit('changeCurrency', {
      loading: false,
      form_nilai_tukar: {
        ...data.form_nilai_tukar,
        id_currency: result.data.object.id_currency_to || '',
        nominal: result.data.object.nominal || '',
        date_kurs: result.data.object.date_kurs
          ? moment(result.data.object.date_kurs).format('DD/MM/YYYY')
          : '',
      },
    });

    return result.error ? false : true;
  },

  async createCurrency({ commit, state, dispatch }) {
    commit('changeCurrency', {
      loading: true,
    });

    let result = await ApiPostRequest(`fin/currency`, state.data.form);
    commit('changeCurrency', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createRateCurrency({ commit, state, dispatch }) {
    commit('changeCurrency', {
      loading: true,
    });

    let result = await ApiPostRequest(
      `fin/currency/price`,
      state.data.form_nilai_tukar
    );
    commit('changeCurrency', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateCurrency({ commit, state, dispatch }, payload = null) {
    commit('changeCurrency', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `fin/currency/${payload.id}`,
      state.data.form
    );

    commit('changeCurrency', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateRateCurrency({ commit, state, dispatch }, payload = null) {
    commit('changeCurrency', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `fin/currency/price/${payload.id}`,
      state.data.form_nilai_tukar
    );

    commit('changeCurrency', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteCurrency({ commit, dispatch }, payload = null) {
    commit('changeCurrency', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/currency/${payload.id}`);
    commit('changeCurrency', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async deleteRateCurrency({ commit, dispatch }, payload = null) {
    commit('changeCurrency', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/currency/price/${payload.id}`);
    commit('changeCurrency', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
